import {
    ActionBarContext,
    addActionBarItem,
    addNavMenuItem,
    DataService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { Injectable } from '@angular/core';
import { map, catchError, tap } from 'rxjs/operators';
import { gql } from 'graphql-tag';
import { Observable } from 'rxjs';

interface retryPOS {
    retryPosi: {
        success: boolean;
        message: string;
    };
}

interface Order {
    order: {
        id: string;
        customFields: {
            positouch_failure: boolean;
        };
    };
}

@Injectable()
class MyService {
    constructor(private readonly dataService: DataService) {}

    retryPositouchPrinting(id: [string]): Observable<retryPOS> {
        const mutation = gql`
            query retryPosi($id: ID!) {
                retryPosi(id: $id) {
                    success
                    message
                }
            }
        `;
        return this.dataService
            .mutate<retryPOS>(mutation, {
                id,
            })
            .pipe(
                catchError(error => {
                    throw error;
                }),
            );
    }
}

export default [
    MyService,
    addActionBarItem({
        id: 'cancel-doordash-delivery',
        locationId: 'order-detail',
        label: 'Retry POSitouch Printing',
        icon: 'bell',
        requiresPermission: 'SuperAdmin',
        buttonColor: 'primary',
        buttonState: (context: ActionBarContext) => {
            const query = gql`
                query order($id: ID!) {
                    order(id: $id) {
                        id
                        customFields {
                            positouch_failure
                        }
                    }
                }
            `;
            return context.dataService
                .query<Order>(query, {
                    id: context.route.snapshot.params.id,
                })
                .mapSingle(response => response.order)
                .pipe(
                    map(order => {
                        return {
                            disabled: !order?.customFields?.positouch_failure,
                            visible: order?.customFields?.positouch_failure,
                        };
                    }),
                );
        },
        onClick: async (event: MouseEvent, context: ActionBarContext) => {
            const orderId = context.route.snapshot.params.id;
            const myService = context.injector.get(MyService);
            const notificationService = context.injector.get(NotificationService);
            myService.retryPositouchPrinting(orderId).subscribe({
                next: response => {
                    const { success, message } = response.retryPosi;
                    if (success) {
                        notificationService.success('Success: POSitouch printing has been retried.');
                    } else {
                        notificationService.error(`Error: ${message}`);
                    }
                },
                error: () => {
                    notificationService.error('Error occurred while retrying POSitouch printing.');
                },
            });
        },
    }),
    addNavMenuItem(
        {
            id: 'positouch-status',
            label: 'Positouch Status',
            requiresPermission: 'SuperAdmin',
            icon: 'inbox',
            routerLink: ['/settings/channels/status'],
        },
        'settings',
    ),
];
